import React from 'react';
import s from './TableElements.module.css';
import {useTranslation} from 'react-i18next';

type Props = {
	money: string | number;
	bonuses: string | number;
	currency?: string;
	comment?: string;
	cashback?: string | number;
	bonus?: string | number;
	createDate?: string;
};
const SubTotalInfo: React.FC<Props> = ({
	money,
	bonuses,
	comment,
	currency = 'грн',
	cashback,
	bonus,
	createDate,
}) => {
	const {t} = useTranslation();
	return (
		<div className={s.subTotalContainer}>
			<div className={s.subTotalContent}>
				<div className={s.subTotalRow}>
					<div className={s.totalRowName}>{t('Загальна кількість балів')}:</div>
					<div className={s.totalRowDate}>{bonuses} б</div>
				</div>
				<div className={s.subTotalRow}>
					<div className={s.totalRowName}>{t('Загальна вартість замовлення')}:</div>
					<div className={s.totalRowDate}>
						{money} {currency}
					</div>
				</div>
				{cashback && (
					<div className={s.subTotalRow}>
						<div className={s.totalRowName}>{t('Розмір кешбека')}:</div>
						<div className={s.totalRowDate}>{cashback} {currency}</div>
					</div>
				)}
				{bonus && (
					<div className={s.subTotalRow}>
						<div className={s.totalRowName}>{t('з них оплачено бонусами')}:</div>
						<div className={s.totalRowDate}>{bonus} {currency}</div>
					</div>
				)}
			</div>
			<div className={s.subTotalComment}>
				{t('Коментар')}: {comment}
			</div>
			{createDate && (
				<div className={s.subTotalComment}>
					{t('Дата створення')}: {createDate}
				</div>
			)}
		</div>
	);
};

export default SubTotalInfo;
